import apiClient from './client.js';

const noCacheConfig = () => ({
  headers: { 'Cache-Control': 'no-cache' },
  params: { ts: Date.now() }
});

export async function getTeamMembers () {
  const { data } = await apiClient.get('/team-management/members', noCacheConfig());
  return data?.members || [];
}

export async function createTeamMember (payload) {
  const { data } = await apiClient.post('/team-management/members', payload);
  return data?.member || null;
}

export async function updateTeamMember (id, payload) {
  const { data } = await apiClient.patch(`/team-management/members/${id}`, payload);
  return data?.member || null;
}

export async function getTeamStats (period) {
  const { data } = await apiClient.get('/team/stats', { params: { period } });
  return data;
}
export async function getTeamFunnels (period) {
  const { data } = await apiClient.get('/team/funnels', { params: { period } });
  return data;
}
export async function getManagerSettings (id) {
  const { data } = await apiClient.get(`/team/managers/${id}/settings`);
  return data;
}
export async function putManagerSettings (id, payload) {
  const { data } = await apiClient.put(`/team/managers/${id}/settings`, payload);
  return data;
}
export async function assignTask (payload) {
  const { data } = await apiClient.post('/tasks/assign', payload);
  return data;
}
